import { styled } from '@mui/material';
import { Chip as ChipMaterial } from '@mui/material';

export const HighChartWrapper = styled('div')`
  position: relative;
  #mr-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 800px;
    width: 100%;
  }
`;

export const Chip = styled(ChipMaterial)`
  margin: 5px;
`;
